// extracted by mini-css-extract-plugin
export default {"imageWrapper":"vF-z","hovered":"wF-z","hoverImage":"xF-z","mainImage":"yF-z","imageNoBackground":"zF-z","fullSizeImage":"AF-z"};